/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ObjectIdBatchRequest {
    getFixupPrototypeFunction() { return ObjectIdBatchRequest.fixupPrototype; }

    static newInstance(model: Partial<ObjectIdBatchRequest>): ObjectIdBatchRequest {
        let obj = Object.assign(new ObjectIdBatchRequest(), model);
        ObjectIdBatchRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ObjectIdBatchRequest>): ObjectIdBatchRequest {
        if (!model) return null;
        return ObjectIdBatchRequest.newInstance(<ObjectIdBatchRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ObjectIdBatchRequest) {
        if (!obj) return;

        models.ObjectIdBatchRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ObjectIdBatchRequest): boolean {
        Object.setPrototypeOf(obj, ObjectIdBatchRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    ids: Array<string>;

}
